import { Security_Status } from '@/__generated__/graphql';
import { MinusScoreIcon } from '@/assets/icons/minusScore';
import { Tooltip } from '@/components/basicComponents/tooltip';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import { getUTCDate } from '@/shared/utils/date';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';
import { recommendedTableColumns } from '../../constants';
import { IInvestorInterestList, TypeWindow } from '../../types';

interface MobileTableProps {
  recommendedData: IInvestorInterestList[];
  openPage: (id: string, type: TypeWindow) => void;
}

const MobileTable = ({ recommendedData, openPage }: MobileTableProps) => {
  const TableRow = ({ el }: { el: IInvestorInterestList }) => {
    return (
      <MobileTableRowWrap key={el.investment.symbol}>
        <MobileRow>
          <MobileRowTitle>{recommendedTableColumns[0].title}</MobileRowTitle>
          <MobileRowValue isRedirect onClick={() => openPage(el.investment.id, 'opportunityDetails')}>
            {el.investment.name}
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{recommendedTableColumns[1].title}</MobileRowTitle>
          <MobileRowValue>
            {el.investment?.subAssetClass
              ? `${el.investment?.assetClass?.name} - ${el.investment?.subAssetClass?.name}`
              : el.investment?.assetClass?.name}
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{recommendedTableColumns[2].title}</MobileRowTitle>
          {el.investment?.subAssetClasses?.length > 1 ? (
            <Tooltip title={el.investment.subAssetClasses.toString().replace(/,/g, ', ')} maxContentWidth={300}>
              <MobileRowValue>Multiple ({el.investment.subAssetClasses.length})</MobileRowValue>
            </Tooltip>
          ) : (
            <MobileRowValue>{el.investment?.subAssetClasses && el.investment?.subAssetClasses[0]}</MobileRowValue>
          )}
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{recommendedTableColumns[3].title}</MobileRowTitle>
          <MobileRowValue>{el.investment.type}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{recommendedTableColumns[4].title}</MobileRowTitle>
          <MobileRowValue>{el.investment.investorDocsDue && getUTCDate(new Date(el.investment.investorDocsDue))}</MobileRowValue>
        </MobileRow>

        {/* {el.investment.securityStatus === Security_Status.Terminated && (
          <TooltipWrapper>
            <Tooltip title="Passed On">
              <MinusScoreIcon width={29} height={29} fill={themeVar('font.disabled')} />
            </Tooltip>
          </TooltipWrapper>
        )} */}
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {recommendedData.length ? (
        recommendedData.map((el, index) => {
          return <TableRow el={el} key={index} />;
        })
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTable;

const TooltipWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
